const defaultPreferenceAction = {
    BACKUP : 'backup',

    SAVE : 'save',

    DISCARD : 'discard'

};

angular.module('gw-um-j2js')
    .constant('defaultPreferenceAction', defaultPreferenceAction);